import SavedSearchModal from '@/core/components/favorites/SavedSearchModal/SavedSearchModal';

export default SavedSearchModal;
